import { CalendarDays } from "lucide-react";
import { DAYS } from "@/lib/services";

export default function ScheduleView({ schedule = [] }) {
  if (!schedule.length) return null;
  const byDay = Object.fromEntries(schedule.map((s) => [s.day, s]));
  const today = (new Date().getDay() + 6) % 7;

  return (
    <div data-testid="schedule-view" className="mt-6 rounded-xl border border-zinc-800 bg-zinc-900/40 p-5">
      <h2 className="flex items-center gap-2 font-serif text-xl text-zinc-200 mb-3"><CalendarDays className="h-5 w-5 text-rose-400" /> Weekrooster</h2>
      <div className="divide-y divide-zinc-800/70">
        {DAYS.map((name, day) => {
          const slot = byDay[day];
          const isToday = day === today;
          return (
            <div key={day} data-testid={`schedule-row-${day}`} className={`flex items-center justify-between py-2 text-sm ${isToday ? "text-zinc-100" : "text-zinc-400"}`}>
              <span className="flex items-center gap-2">
                {name}
                {isToday && <span className="rounded-full bg-rose-600 px-1.5 py-0.5 text-[9px] font-semibold uppercase tracking-wider text-white">Vandaag</span>}
              </span>
              {slot ? <span className="font-mono text-emerald-300">{slot.start} – {slot.end}{slot.end <= slot.start && <span className="ml-1 font-sans text-[11px] text-zinc-500">(volgende dag)</span>}</span> : <span className="text-zinc-600">Gesloten</span>}
            </div>
          );
        })}
      </div>
    </div>
  );
}
